module.exports = __webpack_public_path__ + "img/ARTE.173afcfd.png";